/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable object-curly-newline */
/* eslint-disable react/no-array-index-key */
/* eslint-disable comma-dangle */
/* eslint-disable indent */
import React from 'react';
import { ArrowRight, ArrowDown } from 'lucide-react';

const steps = [
    { id: '01', title: 'Plan & Design', desc: 'Define scope, metering strategy, and system architecture.', arrow: { right: <ArrowRight className="w-5 h-5" />, down: <ArrowDown className="w-5 h-5" /> } },
    { id: '02', title: 'Build & Prepare', desc: 'Pre-configured hardware, tested and deployment-ready.', arrow: { right: <ArrowRight className="w-5 h-5" />, down: <ArrowDown className="w-5 h-5" /> } },
    { id: '03', title: 'Install & Connect', desc: 'Seamless installation of meters, devices, and communications.', arrow: { right: <ArrowRight className="w-5 h-5" />, down: <ArrowDown className="w-5 h-5" /> } },
    { id: '04', title: 'Commission & Test', desc: 'Live system validation and full commissioning with real data.', arrow: { right: <ArrowRight className="w-5 h-5" />, down: <ArrowDown className="w-5 h-5" /> } },
    { id: '05', title: 'Handover & Support', desc: 'Dashboards live, team trained, and ongoing Nube iO support in place.', },
];

const EngagementProcess = () => {
    return (
        <section className="w-full py-20 lg:py-28">
            <div className="container max-w-[1440px] mx-auto px-4 lg:max-w-screen-xl">

                <div className="mb-20">
                    <span className="text-[#459ca5] font-bold text-sm tracking-[0.2em] uppercase">
                        HOW WE ENGAGE
                    </span>
                    <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 tracking-tight text-black dark:text-white">
                        From first conversation to live portfolio.
                    </h2>
                    <p className="mt-6 text-gray-400 font-light leading-relaxed text-base lg:text-xl ">
                        Every Nube iO deployment is delivered in partnership with contractors and stakeholders — a structured process with clear milestones at every stage.
                    </p>
                </div>

                <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-6 hiden">
                    {steps.map((step, index) => (
                        <React.Fragment key={step.id}>
                            <div className="flex flex-col items-center text-center">
                                <div className="w-16 h-16 rounded-full border-2 border-theme-teal flex items-center justify-center text-theme-teal font-bold mb-6 bg-white shrink-0">
                                    {step.id}
                                </div>
                                {(step.title) && (
                                    <h3 className="font-bold text-black mb-3 dark:text-theme-teal">{step.title}</h3>
                                )}
                                {(step.desc) && (
                                    <p className="text-gray-400 leading-relaxed font-light text-sm">{step.desc}</p>
                                )}
                            </div>

                            {index < steps.length - 1 && (
                                <div className="hidden md:flex justify-center items-start pt-5 text-theme-teal">
                                    <ArrowRight className="hidden lg:block w-6 h-6" />
                                </div>
                            )}

                            <div className="md:hidden flex justify-center text-theme-teal py-2">
                                {index < steps.length - 1 && <ArrowDown className="lg:hidden w-6 h-6" />}
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default EngagementProcess;
